import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./Image.module.less";
import classNames from "classnames";

export type ImageProps = {
	name: string;
	trackingId?: string;
	src: string;
	onClick?: () => void;
};

export const Image = (props: ImageProps): ReactElement => {
	const {
		name,
		trackingId,
		src,
		onClick
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{ [styles.root_clickable]: onClick }
			)}
			onClick={onClick}
		>
			<img
				className={styles.image}
				alt={name}
				title={name}
				src={src}
			/>
		</div>
	);
};
Image.displayName = "ContentLayout.Image";